import type { Locale } from '@atlassian/jira-common-constants/src/supported-locales';
import type { State } from '../../types';

export const getBaseUrl = (state: State): string => state.app.baseUrl;
export const getLocale = (state: State): Locale => state.app.locale;
export const getProjectKey = (state: State): string => state.app.projectKey;
export const getProjectId = (state: State): number => state.app.projectId;
export const getIsProjectSimplified = (state: State): boolean => state.app.isProjectSimplified;
export const getIsAdmin = (state: State) => state.app.isAdmin;
export const getActivationId = (state: State): string => state.app.activationId;
export const getCloudId = (state: State): string => state.app.cloudId;
